export default {"src":"/_next/static/media/walmart-logo.1b66f258.svg","height":36,"width":201,"blurWidth":0,"blurHeight":0};